import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import AppFormInput from '../AppFormInput';
import Button from '../Button';
import Api from '../../api';
// import AppImage from '../AppImage';

const ChangePassword = ({
  closeText,
  closeFunction,
  content,
}) => {
  const [user,setUser]= useState({    
    prePass: '',
  newPass: '',
  reNewPass: '',})
  const [showErrorPrePassword, setShowErrorPrePassword] = useState(false);
  const [showErrorNewPassword, setShowErrorNewPassword] = useState(false);
  const [showErrorBoth, setShowErrorBoth] = useState(false);
  const [serverError, setServerError] = useState('');
  const [showErrorNewRePassword, setShowErrorNewRePassword] = useState(false);

  const [pressEnter, setPressEnter] = useState(false);
  const [success, setSuccess] = useState('');

  const changeUserPrePassword = (e) => {
    setUser({ ...user, prePass: e.target.value });
    setServerError('');
    setShowErrorPrePassword(false);
    setPressEnter(false);
    setShowErrorNewRePassword(false);
    setShowErrorNewPassword(false);
  };
  const changeUserNewPassword = (e) => {
    setUser({ ...user, newPass: e.target.value });
    setServerError('');
    setShowErrorNewPassword(false);
    setShowErrorBoth(false);
    setPressEnter(false);
  };

  const changeUserNewRePassword = (e) => {
    setUser({ ...user, reNewPass: e.target.value });
    setServerError('');
    setShowErrorBoth(false);
    setShowErrorNewRePassword(false);
    setPressEnter(false);
  };

  const sendFunction=(e)=>{
    e.preventDefault();
    let check=checkError();
    if(!check){
      Api.changePassword(user)
      .then((res)=>{
        setUser({    
          prePass: '',
        newPass: '',
        reNewPass: ''})
        setServerError('');
        setShowErrorBoth(false);
        setShowErrorNewRePassword(false);
        setPressEnter(false);
        setSuccess(res?.data?.message);

      })
      .catch((err)=>{
        setServerError(err?.response?.data?.message)
      })
    }


  }
  const checkError=()=>{
    let result=false;
    if (user?.newPass?.trim() != user?.reNewPass?.trim()) {
      setShowErrorBoth(true);
      result = true;
    }

    if (user?.prePass?.trim()?.length != 0 && user?.newPass?.trim()?.length == 0) {
      setShowErrorNewPassword(true);
      result = true;
    }
    if (user?.prePass?.trim()?.length != 0 && user?.reNewPass?.trim()?.length == 0) {
      setShowErrorNewRePassword(true);
      result = true;

    }
    if(user?.newPass?.trim()?.length ==0){
      setShowErrorNewPassword(true);
      result = true;

    }
    if(user?.prePass?.trim()?.length ==0){
      setShowErrorPrePassword(true);
      result = true;

    }
    if(user?.reNewPass?.trim()?.length ==0){
      setShowErrorNewRePassword(true);
      result = true;

    }
    return result;
  }
  useEffect(() => {
    if (success?.length != 0) {
      setTimeout(() => {
        setSuccess('');
      }, [3000]);
    }
  }, [success]);
  return (
    <div className={`${styles.container} w-full`}>
      {/* {serverError !== '' && (
        <div className={styles.serverError}>
          <span>{serverError}</span>
        </div>
      )} */}
      {/* <p className={styles.title}>تغییر رمزعبور</p> */}
      {/* <Form onSubmit={submitFormFunction} closeFunction={closeFunction} closeText={closeText} user={user} buttonText='ثبت' extraStyleButton={{ marginTop: '50px' }} className={`w-[80%]`}> */}
      <div
        // user={user}
        extraStyleButton={{ marginTop: '50px' }}
        className={`w-full`}
      >
        <AppFormInput
          inputTitleClass={styles.inputTitleStyle}
          value={user?.prePass}
          onChange={changeUserPrePassword}
          wraperClassName={styles.wrapperInputStyle}
          inputStyle={styles.inputStyle}
          showError={showErrorPrePassword}
          title={content?.changePassword?.prePass?.title}
          error={content?.changePassword?.prePass?.error}
          extraButtonStyle={styles.newSize}
          inputStyle={styles.inputStyle}
          wrapperStyle={`${styles.wrapper} borderBottom`}
        />
        <AppFormInput
          inputTitleClass={styles.inputTitleStyle}
          value={user?.newPass}
          onChange={changeUserNewPassword}
          wraperClassName={styles.wrapperInputStyle}
          inputStyle={styles.inputStyle}
          showError={showErrorNewPassword}
          title={content?.changePassword?.newPass?.title}
          error={content?.changePassword?.newPass?.error}
          extraButtonStyle={styles.newSize}
          inputStyle={styles.inputStyle}
          wrapperStyle={`${styles.wrapper} borderBottom`}
        />
        <AppFormInput
          inputTitleClass={styles.inputTitleStyle}
          value={user?.reNewPass}
          onChange={changeUserNewRePassword}
          wraperClassName={styles.wrapperInputStyle}
          inputStyle={styles.inputStyle}
          showError={showErrorNewPassword}
          title={content?.changePassword?.reNewPass?.title}
          error={content?.changePassword?.reNewPass?.error}
          extraButtonStyle={styles.newSize}
          inputStyle={styles.inputStyle}
          wrapperStyle={`${styles.wrapper} borderBottom`}
        />
        {showErrorBoth == true && (
          <p className={`${styles.inputError} preserveWhiteThemeColor`}>
            {content?.changePassword?.notMatch}
          </p>
        )}
      </div>
      <div className={`flex flex-row justify-start items-center w-full h-auto`}>
      {serverError?.length != 0 && (
        <p className={` inputError preserveWhiteThemeColor`}>{serverError}</p>
      )}
      {success?.length != 0 && (
        <p className={` mainTextColor preserveWhiteThemeColor`}>{success}</p>
      )}
      </div>
      <div
        className={`flex flex-row-reverse justify-start items-center w-full h-auto mt-auto `}
      >
        <Button
          onClick={sendFunction}
          className={`${styles.sendButton} mainBg`}
        >
          {/* {props?.content?.personalInfoModal?.submit} */}
          {content?.changePassword?.submit}
        </Button>
      </div>
      {/* </Form> */}
    </div>
  );
};

export default ChangePassword;
